import { render, staticRenderFns } from "./CustomerAppointsTab.vue?vue&type=template&id=aa681578&"
import script from "./CustomerAppointsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerAppointsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerAppointsTab.vue"
export default component.exports